"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClearExternalErrors = exports.useExternalErrors = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useExternalErrors = function useExternalErrors(setError, errors) {
  (0, _react.useEffect)(function () {
    Object.entries(errors || {}).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          field = _ref2[0],
          message = _ref2[1];

      var msg = Array.isArray(message) ? message[0] : message;

      if (msg) {
        setError(field, {
          message: msg,
          type: 'manual'
        }, {
          shouldFocus: true
        });
      }
    });
  }, [errors, setError]);
};

exports.useExternalErrors = useExternalErrors;

var useClearExternalErrors = function useClearExternalErrors(clearErrors, hasErrors) {
  (0, _react.useEffect)(function () {
    if (!hasErrors) {
      clearErrors();
    }
  }, [clearErrors, hasErrors]);
};

exports.useClearExternalErrors = useClearExternalErrors;